export const NETWORK_STATUS_CHECK_PATH = '/version.json';
export const NETWORK_STATUS_CHECK_DELAY_IN_MILLISECONDS = 5000;
export const NETWORK_STATUS_ERROR_CODE = -1;

export const NETWORK_STATUS_MAX_ENTRIES = 30;

export const SLOW_RESPONSE_TIME_IN_MILLISECONDS = 2000;
export const FAST_RESPONSE_TIME_IN_MILLISECONDS = 1000;
